module.exports = "/_next/static/images/11c8c9f585a36c71ef77d9cd51c8deea-nuconta-inclined-device@0.75x.png";